module.exports = __webpack_public_path__ + "img/thumbnail_DromedaryCamel_f_leucistic.69468ecd.png";